import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
const Index = () => import('./Index.vue');
const Editor = () => import('./Editor.vue');
const Analytics = () => import('./Analytics.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automation-flows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'automation_flows_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'automation_flows_list',
          component: Index,
          meta: {
            permissions: ['administrator', 'automation_manage'],
          },
        },
        {
          path: 'new',
          name: 'automation_flows_new',
          component: Editor,
          meta: {
            permissions: ['administrator', 'automation_manage'],
            fullWidth: true,
          },
        },
        {
          path: ':flowId/edit',
          name: 'automation_flows_edit',
          component: Editor,
          meta: {
            permissions: ['administrator', 'automation_manage'],
            fullWidth: true,
          },
        },
        {
          path: 'analytics',
          name: 'automation_flows_analytics',
          component: Analytics,
          meta: {
            permissions: ['administrator', 'automation_manage'],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
